"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2014-2017 Flowhub UG
//     NoFlo may be freely distributed under the MIT license
var BasePort = require('./BasePort'); // ## NoFlo inport
//
// Input Port (inport) implementation for NoFlo components. These
// ports are the way a component receives Information Packets.


module.exports = /*#__PURE__*/function (_BasePort) {
  _inherits(InPort, _BasePort);

  var _super = _createSuper(InPort);

  function InPort() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, InPort);

    var opts = options;

    if (opts.control == null) {
      opts.control = false;
    }

    if (opts.scoped == null) {
      opts.scoped = true;
    }

    if (opts.triggering == null) {
      opts.triggering = true;
    }

    if (opts.process) {
      throw new Error('InPort process callback is deprecated. Please use Process API');
    }

    if (opts.handle) {
      throw new Error('InPort handle callback is deprecated. Please use Process API');
    }

    _this = _super.call(this, opts);

    _this.prepareBuffer();

    return _this;
  } // Assign a delegate for retrieving data should this inPort


  _createClass(InPort, [{
    key: "attachSocket",
    value: function attachSocket(socket) {
      var _this2 = this;

      var localId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // have a default value.
      if (this.hasDefault()) {
        socket.setDataDelegate(function () {
          return _this2.options["default"];
        });
      }

      socket.on('connect', function () {
        return _this2.handleSocketEvent('connect', socket, localId);
      });
      socket.on('begingroup', function (group) {
        return _this2.handleSocketEvent('begingroup', group, localId);
      });
      socket.on('data', function (data) {
        _this2.validateData(data);

        return _this2.handleSocketEvent('data', data, localId);
      });
      socket.on('endgroup', function (group) {
        return _this2.handleSocketEvent('endgroup', group, localId);
      });
      socket.on('disconnect', function () {
        return _this2.handleSocketEvent('disconnect', socket, localId);
      });
      socket.on('ip', function (ip) {
        return _this2.handleIP(ip, localId);
      });
    }
  }, {
    key: "handleIP",
    value: function handleIP(packet, index) {
      if (this.options.control && packet.type !== 'data') {
        return;
      }

      var ip = packet;
      ip.owner = this.nodeInstance;

      if (this.isAddressable()) {
        ip.index = index;
      }

      if (ip.datatype === 'all') {
        // Stamp non-specific IP objects with port datatype
        ip.datatype = this.getDataType();
      }

      if (this.getSchema() && !ip.schema) {
        // Stamp non-specific IP objects with port schema
        ip.schema = this.getSchema();
      }

      var buf = this.prepareBufferForIP(ip);
      buf.push(ip);

      if (this.options.control && buf.length > 1) {
        buf.shift();
      }

      this.emit('ip', ip, index);
    }
  }, {
    key: "handleSocketEvent",
    value: function handleSocketEvent(event, payload, id) {
      // Emit port event
      if (this.isAddressable()) {
        return this.emit(event, payload, id);
      }

      return this.emit(event, payload);
    }
  }, {
    key: "hasDefault",
    value: function hasDefault() {
      return this.options["default"] !== undefined;
    }
  }, {
    key: "prepareBuffer",
    value: function prepareBuffer() {
      if (this.isAddressable()) {
        if (this.options.scoped) {
          this.scopedBuffer = {};
        }

        this.indexedBuffer = {};
        this.iipBuffer = {};
        return;
      }

      if (this.options.scoped) {
        this.scopedBuffer = {};
      }

      this.iipBuffer = [];
      this.buffer = [];
    }
  }, {
    key: "prepareBufferForIP",
    value: function prepareBufferForIP(ip) {
      if (this.isAddressable()) {
        if (ip.scope != null && this.options.scoped) {
          if (!(ip.scope in this.scopedBuffer)) {
            this.scopedBuffer[ip.scope] = [];
          }

          if (!(ip.index in this.scopedBuffer[ip.scope])) {
            this.scopedBuffer[ip.scope][ip.index] = [];
          }

          return this.scopedBuffer[ip.scope][ip.index];
        }

        if (ip.initial) {
          if (!(ip.index in this.iipBuffer)) {
            this.iipBuffer[ip.index] = [];
          }

          return this.iipBuffer[ip.index];
        }

        if (!(ip.index in this.indexedBuffer)) {
          this.indexedBuffer[ip.index] = [];
        }

        return this.indexedBuffer[ip.index];
      }

      if (ip.scope != null && this.options.scoped) {
        if (!(ip.scope in this.scopedBuffer)) {
          this.scopedBuffer[ip.scope] = [];
        }

        return this.scopedBuffer[ip.scope];
      }

      if (ip.initial) {
        return this.iipBuffer;
      }

      return this.buffer;
    }
  }, {
    key: "validateData",
    value: function validateData(data) {
      if (!this.options.values) {
        return;
      }

      if (this.options.values.indexOf(data) === -1) {
        throw new Error("Invalid data='".concat(data, "' received, not in [").concat(this.options.values, "]"));
      }
    }
  }, {
    key: "getBuffer",
    value: function getBuffer(scope, index) {
      var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.isAddressable()) {
        if (scope != null && this.options.scoped) {
          if (!(scope in this.scopedBuffer)) {
            return undefined;
          }

          if (!(index in this.scopedBuffer[scope])) {
            return undefined;
          }

          return this.scopedBuffer[scope][index];
        }

        if (initial) {
          if (!(index in this.iipBuffer)) {
            return undefined;
          }

          return this.iipBuffer[index];
        }

        if (!(index in this.indexedBuffer)) {
          return undefined;
        }

        return this.indexedBuffer[index];
      }

      if (scope != null && this.options.scoped) {
        if (!(scope in this.scopedBuffer)) {
          return undefined;
        }

        return this.scopedBuffer[scope];
      }

      if (initial) {
        return this.iipBuffer;
      }

      return this.buffer;
    }
  }, {
    key: "getFromBuffer",
    value: function getFromBuffer(scope, index) {
      var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var buf = this.getBuffer(scope, index, initial);

      if (!(buf != null ? buf.length : undefined)) {
        return undefined;
      }

      if (this.options.control) {
        return buf[buf.length - 1];
      }

      return buf.shift();
    } // Fetches a packet from the port

  }, {
    key: "get",
    value: function get(scope, index) {
      var res = this.getFromBuffer(scope, index);

      if (res !== undefined) {
        return res;
      } // Try to find an IIP instead


      return this.getFromBuffer(null, index, true);
    }
  }, {
    key: "hasIPinBuffer",
    value: function hasIPinBuffer(scope, index, validate) {
      var initial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var buf = this.getBuffer(scope, index, initial);

      if (!(buf != null ? buf.length : undefined)) {
        return false;
      }

      for (var i = 0; i < buf.length; i += 1) {
        if (validate(buf[i])) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "hasIIP",
    value: function hasIIP(index, validate) {
      return this.hasIPinBuffer(null, index, validate, true);
    } // Returns true if port contains packet(s) matching the validator

  }, {
    key: "has",
    value: function has(scope, index, validate) {
      var valid = validate;
      var idx = index;

      if (!this.isAddressable()) {
        valid = idx;
        idx = null;
      }

      if (this.hasIPinBuffer(scope, idx, valid)) {
        return true;
      }

      if (this.hasIIP(idx, valid)) {
        return true;
      }

      return false;
    } // Returns the number of data packets in an inport

  }, {
    key: "length",
    value: function length(scope, index) {
      var buf = this.getBuffer(scope, index);

      if (!buf) {
        return 0;
      }

      return buf.length;
    } // Tells if buffer has packets or not

  }, {
    key: "ready",
    value: function ready(scope) {
      return this.length(scope) > 0;
    } // Clears inport buffers

  }, {
    key: "clear",
    value: function clear() {
      return this.prepareBuffer();
    }
  }]);

  return InPort;
}(BasePort);